import axios from "../axios-auth";

export const shiftAssignService = {
  getShiftAssignList,
  getAllShiftAssignList,
  getShiftAssignDetail,
  saveShiftAssign
};

function getShiftAssignList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  }
  else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shiftInfoId) {
    params["shiftInfoId"] = searchParams.shiftInfoId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }

  return axios.get("/auth/shift-assigns", { params });
}

function getAllShiftAssignList(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shiftInfoId) {
    params["shiftInfoId"] = searchParams.shiftInfoId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.updateUserId) {
    params["updateUserId"] = searchParams.updateUserId;
  }

  return axios.get("/auth/shift-assigns", { params });
}

function saveShiftAssign(shiftAssign) {
  if (!shiftAssign.id) {
    // new shiftInfo
    return axios.post("/auth/shift-assign", shiftAssign);
  } else {
    // edit
    return axios.put("/auth/shift-assign", shiftAssign);
  }
}

function getShiftAssignDetail(id) {
  return axios.get('/auth/shift-assign/' + id);
}